import styled from 'styled-components';

import { ds } from '@/config/colors';
import { media } from '@/utils';

export const FilterBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* Pasek filtrów bez ramki, tła i wcięć z boków: kontrolki równają do krawędzi treści (DS). */
  padding: 12px 0;
  background: transparent;
  border: none;
  border-radius: 0;
  margin: 20px 0 0 0;
  gap: 20px;

  @media (max-width: 1200px) {
    flex-wrap: wrap;
  }

  ${media.mobile} {
    flex-direction: row;
    align-items: center;
    margin-top: 8px;
    padding: 8px 0;
    gap: 10px;
  }
`;

export const FilterBarSection = styled.div<{ $position?: 'left' | 'right' }>`
  display: flex;
  align-items: center;
  gap: 12px;

  ${(props) => props.$position === 'left' && `
    flex: 1;
    min-width: 0;
  `}

  ${(props) => props.$position === 'right' && `
    white-space: nowrap;
  `}

  ${media.mobile} {
    gap: 8px;

    ${(props) => props.$position === 'left' && `
      flex: 1;
      min-width: 0;
    `}

    ${(props) => props.$position === 'right' && `
      flex-shrink: 0;
    `}
  }
`;

export const FilterLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.secondary};
  white-space: nowrap;
`;

/* Na telefonie renderowany tylko w popoverze filtrów (FiltersPanel). */
export const ItemsPerPageWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  ${media.mobile} {
    justify-content: space-between;
  }
`;

export const SearchInputWrapper = styled.div`
  flex: 1;
  min-width: 0;
  max-width: 340px;
 

  ${media.mobile} {
    max-width: 100%;
    flex: 1;

    input {
      font-size: 14px;
   
    }

    /* Make input smaller on mobile */
    .group {
      width: 100%;
    }
  }
`;

export const ViewModeToggle = styled.div`
  display: flex;
  align-items: center;
  background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#f3f4f6')};
  border-radius: 6px;
  padding: 4px;
  gap: 4px;
`;

export const ViewModeButton = styled.button<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 6px;
  background: ${(props) => {
    if (props.$isActive) return props.theme.colors.card.background;
    return 'transparent';
  }};
  color: ${(props) => {
    if (props.$isActive) return props.theme.colors.text.primary;
    return props.theme.colors.text.secondary;
  }};
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: ${(props) => (props.$isActive ? '0 1px 3px rgba(0, 0, 0, 0.1)' : 'none')};

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
    background: ${(props) => {
    if (props.$isActive) return props.theme.colors.card.background;
    return props.theme.mode === 'dark' ? '#4b5563' : '#e5e7eb';
  }};
  }

  &:active {
    transform: scale(0.95);
  }
`;

/* Telefon: przycisk z ikoną filtra obok wyszukiwarki, tej samej wysokości co pole (44 px). */
export const FiltersButton = styled.button<{ $active?: boolean }>`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  padding: 0;
  border-radius: 8px;
  border: 1px solid ${({ $active }) => ($active ? ds.textPrimary : ds.borderStrong)};
  background: ${({ theme }) => (theme.mode === 'dark' ? '#1a1f26' : '#ffffff')};
  color: ${({ theme }) => theme.colors.text.primary};
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  svg {
    width: 18px;
    height: 18px;
  }

  &:focus-visible {
    outline: 2px solid ${ds.accentInk};
    outline-offset: 2px;
  }
`;

/* Kropka na ikonie: jakiś filtr jest ustawiony. */
export const FiltersActiveDot = styled.span`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${ds.textPrimary};
  border: 2px solid #ffffff;
  box-sizing: content-box;
`;

/* Zawartość arkusza filtrów: kontrolki jedna pod drugą, na całą szerokość. */
export const FiltersPanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 14px;
  width: 100%;
  padding: 8px 0 4px;

  & > * {
    max-width: 100%;
    flex-wrap: wrap;
  }
`;

/** Zamknięcie arkusza filtrów: pełna szerokość, czarny jak główne CTA. */
export const FiltersDoneButton = styled.button`
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 9999px;
  background: ${ds.textPrimary};
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
`;
